var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnyxXLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 73.949432 73.961334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Path_147193",
    "data-name": "Path 147193",
    d: "m 51.319763,43.941668 a 5.228,5.228 0 0 0 -7.395,7.392 l 21.08,21.078 a 5.227,5.227 0 1 0 7.392,-7.392 z",
    style: {
      fill: "#ff1b00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147194",
    "data-name": "Path 147194",
    d: "m 22.610763,43.941668 -21.0780005,21.078 a 5.2297625,5.2297625 0 1 0 7.4,7.392 l 21.0730005,-21.08 a 5.228,5.228 0 1 0 -7.395,-7.392 z",
    style: {
      fill: "#009f33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147195",
    "data-name": "Path 147195",
    d: "m 47.621763,31.549668 a 5.211,5.211 0 0 0 3.7,-1.53 l 21.078,-21.0779998 a 5.227,5.227 0 1 0 -7.392,-7.392 l -21.08,21.0779998 a 5.227,5.227 0 0 0 3.7,8.923 z",
    style: {
      fill: "#ff1b00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147196",
    "data-name": "Path 147196",
    d: "m 8.9297625,1.5496682 a 5.2297625,5.2297625 0 0 0 -7.4,7.392 L 22.607763,30.019668 a 5.228,5.228 0 0 0 7.395,-7.392 z",
    style: {
      fill: "#009f33"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2831",
    "data-name": "Ellipse 2831",
    cx: 36.95977,
    cy: 36.968666,
    r: 5.2690001,
    style: {
      fill: "#ffffff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnyxXLogo);
export default __webpack_public_path__ + "static/media/ONYX_X_logo.0b7d44f535b0376b05e7b08fb2caa594.svg";
export { ForwardRef as ReactComponent };